import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams, Events } from 'ionic-angular';
import { EbsWebService } from "../../services/ebsWebService";
import { SignaturePad } from "angular2-signaturepad/signature-pad";
declare var $;

@Component({
  selector: 'signature',
  templateUrl: 'signature.html',
  providers: [EbsWebService]
})
export class Signature {

  title: any;
  signatureElement: any;


  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  public signaturePadOptions: Object = {
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300
  };

  showSpinner: boolean = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    private _ebsWebService: EbsWebService,
    public loadingCtrl: LoadingController) {
    this.signatureElement = navParams.get('signatureElement');
    this.title = this.signatureElement.Caption;

    //events.publish("reloadMenu");
  }

  ionViewCanLeave() {
    return new Promise((resolve, reject) => {
      this.showSpinner = true;
      let base64 = encodeURIComponent(this.signaturePad.toDataURL().split(',')[1]);
      let params = this.signatureElement.ListItemAction[0].PostParameters.replace("FILEBYTES", base64);
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
      this._ebsWebService.postData(this.signatureElement.ListItemAction[0].ActionUrl, postPayloadObject).toPromise().then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      })
    });
  }

  ngAfterViewInit() {
    let canvasWidth = $("signature .scroll-content").width() - 20;
    this.signaturePad.set('minWidth', 5);
    this.signaturePad.set('canvasWidth', canvasWidth);
    this.signaturePad.set('canvasHeight', 500);
    this.signaturePad.set('backgroundColor', 'rgb(255,255,255)');
    this.signaturePad.clear();
  }

  drawComplete() {

  }

  drawStart() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/signature/signature.ts